import React, { useState } from 'react';
import './PaymentForm.css';
import PayPalPayment from './PayPalPayment';

function PaymentForm({ onSuccess, onCancel, userEmail }) {
  const [isProcessing, setIsProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showPayPal, setShowPayPal] = useState(false);

  const handlePayPalPayment = () => {
    setShowPayPal(true);
  };

  const handlePayPalSuccess = (data) => {
    console.log('✅ PayPal payment successful:', data);
    onSuccess(data);
  };

  const handlePayPalCancel = () => {
    setShowPayPal(false);
  };

  if (showPayPal) {
    return (
      <PayPalPayment
        onSuccess={handlePayPalSuccess}
        onCancel={handlePayPalCancel}
        userEmail={userEmail}
      />
    );
  }

  return (
    <div className="payment-form">
      <div className="payment-header">
        <h3>🚀 Upgrade to Swift Notes Pro</h3>
        <div className="payment-price">
          <span className="price-amount">$9.99</span>
          <span className="price-period">/month</span>
        </div>
      </div>

      <div className="payment-benefits">
        <h4>✨ Pro Features:</h4>
        <ul>
          <li>✅ Unlimited notes and folders</li>
          <li>✅ AI-powered note enhancement</li>
          <li>✅ Advanced search and organization</li>
          <li>✅ Priority support</li>
          <li>✅ Early access to new features</li>
        </ul>
      </div>

      <div className="payment-form-content">
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            value={userEmail || ''}
            readOnly
            className="email-input"
          />
        </div>

        {errorMessage && (
          <div className="error-message">
            ❌ {errorMessage}
          </div>
        )}

        <div className="payment-actions">
          <button
            type="button"
            onClick={handlePayPalPayment}
            disabled={isProcessing}
            className="paypal-button"
          >
            {isProcessing ? (
              <>
                <span className="spinner"></span>
                Processing...
              </>
            ) : (
              <>
                <img src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_100x26.png" alt="PayPal" />
                Pay with PayPal
              </>
            )}
          </button>
          
          <button
            type="button"
            onClick={onCancel}
            className="cancel-button"
            disabled={isProcessing}
          >
            Cancel
          </button>
        </div>

        <div className="payment-security">
          <p>🔒 Secure payment powered by PayPal</p>
          <p>💳 No credit card required - use your PayPal balance</p>
          <p>🔄 Cancel anytime from your PayPal account</p>
        </div>
      </div>
    </div>
  );
}

export default PaymentForm; 